// Shared number/money formatting (Finnish). Dates live in ./dates.

const EUR = new Intl.NumberFormat('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Finnish euro amount, e.g. 12,00 (no symbol — callers append " €"). */
export function eur(n: number | null | undefined): string {
  return EUR.format(n ?? 0);
}
